import { render, staticRenderFns } from "./scoreboardVertical.vue?vue&type=template&id=3f113f08&scoped=true&"
import script from "./scoreboardVertical.vue?vue&type=script&lang=js&"
export * from "./scoreboardVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f113f08",
  null
  
)

export default component.exports